module.exports = __webpack_public_path__ + "assets/img/second_user_s.016b8c57.svg";